import { graphql, useStaticQuery } from 'gatsby';

import { DataEdges } from '../types/i18n';

export interface MarketoFormQuery {
  i18nData: DataEdges;
}

const useMarketoForm = () => {
  const { i18nData } = useStaticQuery<MarketoFormQuery>(
    graphql`
      {
        i18nData: allFile(filter: { sourceInstanceName: { eq: "i18n" } }) {
          edges {
            node {
              name
              childSrcJson {
                mktg_ct_all_default_form_heading
                mktg_ct_all_default_form_thankyou_message
                mktg_mkto_fail_header
                mktg_unsub_checkbox_error
                mktg_mkto_fail_adblocker
                mktg_mkto_fail_problem
                mtkg_submit_policy
                mktg_generics_forms_submit
                mktg_mkto_aria_validation
              }
            }
          }
        }
      }
    `,
  );

  return i18nData;
};

export default useMarketoForm;
